import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from '@app/components/layout/layout.component';
// HOME
import { LoginComponent } from './pages/home/login/login.component';
import { DashboardComponent } from './pages/home/dashboard/dashboard.component';
import { AlterarSenhaComponent } from './pages/home/alterar-senha/alterar-senha.component';
import { MeAviseTransferenciaComponent } from './pages/home/me-avise-transferencia/me-avise-transferencia.component';
// Modulo ???
import { ReciboComponent } from './pages/financeiro/recibo/recibo.component';
import { ReciboMultiploComponent } from './pages/financeiro/recibo-multiplo/recibo-multiplo.component';
import { AuthGuard } from '@app/guards/auth.guard';
import { environment } from 'environments/environment';
import { RecuperarSenhaComponent } from './pages/home/recuperar-senha/recuperar-senha.component';
import { RedefinirSenhaComponent } from './pages/home/redefinir-senha/redefinir-senha.component';
import { AutenticacaoDoisFatoresComponent } from './pages/home/autenticacao-dois-fatores/autenticacao-dois-fatores.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'recuperar-senha', component: RecuperarSenhaComponent },
  { path: 'autenticacao-dois-fatores', component: AutenticacaoDoisFatoresComponent},
  { path: 'redefinir-senha/:hashTemporaria/:timeStampExpiracao', component: RedefinirSenhaComponent }, // acrescentar parametro de token
  { path: 'recibo/:tipo/:documento', component: ReciboComponent },
  { path: 'recibo-multiplo', component: ReciboMultiploComponent },
  {
    path: '', component: LayoutComponent, children: [
      { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
      { path: 'alterarsenha', component: AlterarSenhaComponent, canActivate: [AuthGuard] },
      { path: 'meavise/:id', component: MeAviseTransferenciaComponent, canActivate: [AuthGuard] },
      { path: 'cadastros', loadChildren: () => import('./pages/cadastros/cadastros.module').then(m => m.CadastrosModule) },
      { path: 'processos', loadChildren: () => import('./pages/processos/processos.module').then(m => m.ProcessosModule) },
      { path: 'financeiro', loadChildren: () => import('./pages/financeiro/financeiro.module').then(m => m.FinanceiroModule) },
      { path: 'agenda', loadChildren: () => import('./pages/agenda/agenda.module').then(m => m.AgendaModule) },
      { path: 'peticao', loadChildren: () => import('./pages/peticao/peticao.module').then(m => m.PeticaoModule) },
      { path: 'relatorios', loadChildren: () => import('./pages/relatorios/relatorios.module').then(m => m.RelatoriosModule) },
      { path: 'configuracoes', loadChildren: () => import('./pages/configuracoes/configuracoes.module').then(m => m.ConfiguracoesModule) }
    ]
  },
  { path: 'login', children: [{ path: '', component: LoginComponent }] },
  { path: 'sistema', children: environment.CARDEAL_EDICAO === 'CLIENTE'
    ? [{ path: 'administrativo', loadChildren: () => import('./pages/administrativo-clientes/administrativo-clientes.module').then(m => m.AdministrativoClientesModule) }]
    : []
  }
];
@NgModule({
  imports: [RouterModule.forRoot(
    routes,
    { useHash: true,
      enableTracing: false
    }
  )],
  exports: [RouterModule]
})
export class AppRoutingModule {}
